import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export function PublicFooter() {
  return (
    <footer className="border-t border-border/50" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
        <Link to="/" className="hover:opacity-80 transition-opacity" data-testid="footer-home"><Logo /></Link>
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          <Link to="/pricing" className="hover:text-foreground transition-colors" data-testid="footer-pricing">Pricing</Link>
          <Link to="/demo" className="hover:text-foreground transition-colors" data-testid="footer-demo">Request demo</Link>
          <Link to="/legal/terms" className="hover:text-foreground transition-colors" data-testid="footer-terms">Terms of Service</Link>
          <Link to="/legal/privacy" className="hover:text-foreground transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
        </div>
        <p data-testid="footer-copyright">© 2026 SAG LLC</p>
      </div>
    </footer>
  );
}
